import { render, staticRenderFns } from "./WordsList.vue?vue&type=template&id=006e9db3&"
import script from "./WordsList.vue?vue&type=script&lang=js&"
export * from "./WordsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports